<template lang="pug">
.equipment-show-card
  .spinner-container.form-spinner(v-if="loading")
    q-spinner(color="primary", size="3em")

  div(v-if="!loading")
    q-card-section
      component(
        ref="actions",
        v-if="showData['actions']",
        :is="getShowComponent('actions')",
        @refresh-table="refreshTable",
        @open-form="openForm",
        :parentData="{ row: row, grid: grid, grid_key: gridKey, path: path, data: showData['actions'] }"
      )

    q-card-section
      component(
        ref="blocks",
        v-if="showData['blocks']",
        :is="getShowComponent('blocks')",
        :parentData="{ row: row, show_details: false, data: showData['blocks'] }"
      )
</template>

<script>
import showComponents from "../../../../shared/show_card_components/index";

export default {
  components: {
    showComponents,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      path: this.parentData.path,
      grid: this.parentData.grid,
      gridKey: this.parentData.grid_key,
      rowId: this.parentData.row_id,
      tabName: this.parentData.tab_name,
      row: this.parentData.row,
      showData: this.parentData.data,
    };
  },

  computed: {
    loading() {
      return this.parentData.loading;
    },
  },

  methods: {
    refreshTable(data) {
      this.$emit("refresh-table", data);
    },

    refreshRow(data) {
      this.row = data.attr.data || data.attr;
    },

    openForm(data) {
      this.$emit("open-form", data);
    },
  },
};
</script>

<style lang="scss">
.equipment-show-card {
  min-height: 70vh;

  .spinner-container.form-spinner {
    height: 70vh;
  }

  .remain-block {
    margin-top: 50px !important;
  }
}
</style>
